export default __webpack_public_path__ + "static/media/household.685b10b7.svg";